/**
 * App.tsx — Router shell (إتقان)
 *
 * - Dark mode only (Law #5).
 * - Three routes: / (StaticHome), /privacy, /terms.
 * - All routes are statically prerendered at build time (Zero-JS for content).
 * - ErrorBoundary kept for production safety.
 *
 * The router is intentionally minimal — no data loaders, no lazy splits for
 * legal pages (they're tiny). Each route is server-rendered and hydrated.
 */
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ErrorBoundary } from "./components/ErrorBoundary";
import StaticHome from "./pages/StaticHome";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Joffreysme from "./pages/Joffreysme";
import Olayabrightness from "./pages/Olayabrightness";
import Lp1 from "./pages/Lp1";
import BlogAdmin from "./pages/BlogAdmin";
import AdminGate from "./components/admin/AdminGate";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";

const App = () => (
  <HelmetProvider>
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<StaticHome />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/joffreysme" element={<Joffreysme />} />
        <Route path="/olayabrightness" element={<Olayabrightness />} />
        <Route path="/lp1" element={<Lp1 />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/admin" element={<AdminGate><BlogAdmin /></AdminGate>} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        {/* Anything else falls through; hosting layer handles 301 to / */}
        <Route path="*" element={<StaticHome />} />
      </Routes>
    </ErrorBoundary>
  </HelmetProvider>
);

export default App;
